export default __webpack_public_path__ + "static/media/1911.8c1c9ddb.png";